/* hero carousel */
(function () {
  'use strict';

  var ROOT = '[data-yg-hero-carousel]';
  var instances = {};

  var DRAG_THRESHOLD = 5;
  var COMMIT_RATIO = 0.5;
  var QUICK_MS = 300;
  var TAP_SLOP = 20;
  var COOLDOWN_BUFFER = 120;

  function matches(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function currentX(el) {
    var value = window.getComputedStyle(el).transform;
    if (!value || value === 'none') return 0;
    var open = value.indexOf('(');
    var close = value.lastIndexOf(')');
    if (open < 0 || close < 0) return 0;
    var parts = value.slice(open + 1, close).split(',');
    var x = parseFloat(parts.length > 6 ? parts[12] : parts[4]);
    return isNaN(x) ? 0 : x;
  }

  function attach(root) {
    var slidesEl = root.querySelector('.yg-hc__slides');
    var trackEl = root.querySelector('[data-yg-hc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-yg-hc-slide]'));
    if (!slidesEl || !trackEl || !slides.length) return null;

    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-yg-hc-bar]'));
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var duration = parseInt(root.getAttribute('data-duration'), 10) || 300;
    var fine = matches('(hover: hover) and (pointer: fine)');
    var mobileMq = window.matchMedia('(max-width: 749px)');

    var current = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) current = i;
    }

    var slotOf = [];
    for (i = 0; i < slides.length; i++) slotOf[i] = i;

    var timer = null;
    var settleTimer = null;
    var hidden = document.hidden;
    var editorHold = false;
    var moveId = 0;
    var moveStart = 0;

    var dragging = false;
    var moved = false;
    var suppressClick = false;
    var dragPrepared = 0;
    var dragOrigin = 0;
    var dragAnchorX = 0;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var downAt = 0;
    var pendingDx = 0;
    var moveRaf = 0;
    var activePointer = null;
    var lastClickMove = 0;
    var queuedClick = 0;
    var queueTimer = null;

    function span() {
      return slidesEl.offsetWidth || 1;
    }

    function nextIndex() {
      return (current + 1) % slides.length;
    }

    function prevIndex() {
      return (current - 1 + slides.length) % slides.length;
    }

    function setSlot(index, slot) {
      if (slotOf[index] === slot) return;
      slotOf[index] = slot;
      slides[index].style.left = slot * 100 + '%';
    }

    function setTrack(px) {
      trackEl.style.transform = 'translate3d(' + px + 'px,0,0)';
    }

    /* slots whose slide overlaps the viewport at track position x */
    function visibleRange(x) {
      var w = span();
      return {
        lo: Math.ceil((-w - x) / w + 0.000001),
        hi: Math.floor((w - x) / w - 0.000001),
      };
    }

    function videoAt(index) {
      var slide = slides[index];
      if (!slide) return null;
      var want = mobileMq.matches ? 'mobile' : 'desktop';
      return slide.querySelector(
        '[data-yg-hc-video="' + want + '"],[data-yg-hc-video="both"]'
      );
    }

    function warm(index) {
      var video = videoAt(index);
      if (!video) return;
      if (video.getAttribute('preload') === 'none') {
        video.setAttribute('preload', 'auto');
        video.load();
      }
    }

    function playAt(index) {
      var video = videoAt(index);
      if (!video) return;
      warm(index);
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }

    function pauseAt(index) {
      var video = videoAt(index);
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    function pauseAllIn(index) {
      var slide = slides[index];
      if (!slide) return;
      var all = slide.querySelectorAll('video');
      for (var i = 0; i < all.length; i++) {
        all[i].pause();
        try {
          all[i].currentTime = 0;
        } catch (e) {}
      }
    }

    function onBreakpoint() {
      for (var i = 0; i < slides.length; i++) pauseAllIn(i);
      playAt(current);
      warm(nextIndex());
    }

    function runBar(index) {
      for (var i = 0; i < bars.length; i++) {
        var fill = bars[i].firstElementChild;
        if (!fill) continue;
        fill.style.animation = 'none';
        bars[i].classList.toggle('is-active', i === index);
      }
      var active = bars[index];
      if (!active || !active.firstElementChild) return;
      var activeFill = active.firstElementChild;
      void activeFill.offsetWidth;
      activeFill.style.animation = 'yg-hc-fill ' + interval + 'ms linear forwards';
    }

    function freezeBar(index) {
      var active = bars[index];
      if (!active || !active.firstElementChild) return;
      active.firstElementChild.style.animationPlayState = 'paused';
    }

    function syncExposure() {
      for (var i = 0; i < slides.length; i++) {
        var on = i === current;
        slides[i].classList.toggle('is-active', on);
        if (on) {
          slides[i].removeAttribute('aria-hidden');
          slides[i].removeAttribute('inert');
        } else {
          slides[i].setAttribute('aria-hidden', 'true');
          slides[i].setAttribute('inert', '');
        }
      }
    }

    function clearSettle() {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
    }

    /* current back to slot 0 with its neighbours either side, track back to
       zero. Only ever runs when current alone fills the viewport, so the
       reshuffle is invisible. */
    function recenter() {
      var used = {};
      setSlot(current, 0);
      used[current] = true;

      var nx = nextIndex();
      if (!used[nx]) {
        setSlot(nx, 1);
        used[nx] = true;
      }
      var pv = prevIndex();
      if (!used[pv]) {
        setSlot(pv, -1);
        used[pv] = true;
      }

      var spare = 2;
      for (var i = 0; i < slides.length; i++) {
        if (!used[i]) setSlot(i, spare++);
      }
      setTrack(0);
    }

    function settle() {
      clearSettle();
      if (dragging) return;
      root.classList.remove('is-animating');
      recenter();
      syncExposure();
      for (var i = 0; i < slides.length; i++) {
        if (i !== current) pauseAt(i);
      }
    }

    function armSettle() {
      clearSettle();
      var id = moveId;
      settleTimer = setTimeout(function () {
        if (id === moveId) settle();
      }, duration + 80);
    }

    /* Every slide change starts here. The track is frozen at its real
       position, the target is slotted adjacent to whatever is on screen,
       and the whole lot is flushed before the move begins - so an interrupt
       continues from where the eye last saw it. Slots stay contiguous
       across the viewport, so no gap can open. */
    function beginMove(target, back) {
      var x = currentX(trackEl);
      var vis = visibleRange(x);

      root.classList.remove('is-animating', 'is-dragging');
      setTrack(x);

      var slot;
      if (slotOf[target] >= vis.lo && slotOf[target] <= vis.hi) {
        slot = slotOf[target];
      } else {
        slot = back ? vis.lo - 1 : vis.hi + 1;
      }

      var spare = Math.max(vis.hi, slot) + 1;
      for (var i = 0; i < slides.length; i++) {
        if (i === target) continue;
        if (slotOf[i] >= vis.lo && slotOf[i] <= vis.hi) continue;
        setSlot(i, spare++);
      }
      setSlot(target, slot);

      void trackEl.offsetWidth;

      current = target;
      moveId++;
      moveStart = Date.now();
      root.classList.add('is-animating');
      setTrack(-slot * span());

      syncExposure();
      playAt(current);
      runBar(current);
      warm(nextIndex());
      armSettle();
    }

    function snapBack() {
      void trackEl.offsetWidth;
      moveId++;
      moveStart = Date.now();
      root.classList.add('is-animating');
      setTrack(-slotOf[current] * span());
      runBar(current);
      armSettle();
    }

    function goTo(next, back) {
      if (next === current || !slides[next]) return;
      clearSettle();
      beginMove(next, back);
    }

    function advance() {
      goTo(nextIndex(), false);
      schedule();
    }

    function clear() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function schedule() {
      clear();
      if (hidden || editorHold || dragging || slides.length < 2) return;
      timer = setTimeout(advance, interval);
    }

    function onVisibility() {
      hidden = document.hidden;
      if (hidden) {
        clear();
        freezeBar(current);
        pauseAt(current);
      } else {
        playAt(current);
        runBar(current);
        schedule();
      }
    }

    /* put the slide the drag is pulling in on the leading edge, once per
       direction. No video work here - a load() mid-gesture hitches. */
    function prepare(dir) {
      if (dragPrepared === dir) return;
      dragPrepared = dir;

      var x = currentX(trackEl);
      var vis = visibleRange(x);
      var want = dir === 1 ? vis.hi + 1 : vis.lo - 1;
      var who = dir === 1 ? nextIndex() : prevIndex();

      if (slotOf[who] === want) return;
      if (slotOf[who] >= vis.lo && slotOf[who] <= vis.hi) return;

      for (var i = 0; i < slides.length; i++) {
        if (i === who || slotOf[i] !== want) continue;
        if (slotOf[i] >= vis.lo && slotOf[i] <= vis.hi) return;
        setSlot(i, want + dir * slides.length);
      }
      setSlot(who, want);
    }

    /* only now is this known to be a drag, so this is where the running
       transition gets taken over - a plain click never touches it */
    function confirmDrag(event) {
      clearQueue();
      clearSettle();
      root.classList.remove('is-animating');
      dragOrigin = currentX(trackEl);
      setTrack(dragOrigin);
      root.classList.add('is-dragging');
      dragAnchorX = event.clientX;
    }

    function paintDrag() {
      moveRaf = 0;
      if (!dragging) return;
      setTrack(dragOrigin + pendingDx);
    }

    function detach() {
      if (moveRaf) {
        cancelAnimationFrame(moveRaf);
        moveRaf = 0;
      }
      try {
        if (activePointer !== null) slidesEl.releasePointerCapture(activePointer);
      } catch (e) {}
      activePointer = null;
      root.classList.remove('is-dragging');
    }

    function onPointerDown(event) {
      suppressClick = false;
      if (event.button != null && event.button !== 0) return;
      if (event.target.closest && event.target.closest('a, button')) return;
      if (slides.length < 2) return;

      clear();

      dragging = true;
      moved = false;
      dragPrepared = 0;
      pendingDx = 0;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      downAt = Date.now();

      freezeBar(current);
      activePointer = event.pointerId;
      try {
        slidesEl.setPointerCapture(event.pointerId);
      } catch (e) {}
    }

    function onPointerMove(event) {
      if (!dragging) return;

      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (!moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        /* 45 degree lock: a mostly-vertical gesture belongs to the page */
        if (Math.abs(dy) > Math.abs(dx)) {
          dragging = false;
          detach();
          schedule();
          return;
        }
        moved = true;
        confirmDrag(event);
      }

      prepare(dx < 0 ? 1 : -1);

      lastX = event.clientX;
      pendingDx = event.clientX - dragAnchorX;
      if (!moveRaf) moveRaf = requestAnimationFrame(paintDrag);
    }

    function release(cancelled) {
      if (!dragging) return;
      dragging = false;
      detach();

      if (!moved) {
        schedule();
        return;
      }

      var dx = lastX - startX;
      var travelled = Math.abs(dx);

      /* at or under the slop this was a click that drifted, whatever it took:
         put the track back and let onClick navigate by which half was hit */
      if (travelled <= TAP_SLOP) {
        snapBack();
        schedule();
        return;
      }

      suppressClick = true;

      var far = travelled > span() * COMMIT_RATIO;
      var quick = Date.now() - downAt < QUICK_MS;

      if (!cancelled && (far || quick)) {
        beginMove(dx < 0 ? nextIndex() : prevIndex(), dx > 0);
      } else {
        snapBack();
      }
      schedule();
    }

    function onPointerUp() {
      release(false);
    }

    function onPointerCancel() {
      release(true);
    }

    function onLostCapture() {
      release(true);
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    function onTransitionEnd(event) {
      if (dragging) return;
      if (event.propertyName !== 'transform') return;
      if (event.target !== trackEl) return;
      if (Date.now() - moveStart < duration - 50) return;
      settle();
    }

    /* Click-driven advances only. Drag is direct manipulation and stays
       unthrottled, autoplay's interval already dwarfs this, and editor
       selection must jump immediately. The window rides the duration
       setting so raising the slider cannot outrun it. */
    function clickCooldown() {
      return duration + COOLDOWN_BUFFER;
    }

    function clearQueue() {
      queuedClick = 0;
      if (queueTimer) {
        clearTimeout(queueTimer);
        queueTimer = null;
      }
    }

    function runClickMove(back) {
      lastClickMove = Date.now();
      clear();
      goTo(back ? prevIndex() : nextIndex(), back);
      schedule();
    }

    function requestClickMove(back) {
      var waited = Date.now() - lastClickMove;
      var window_ = clickCooldown();
      if (waited >= window_) {
        runClickMove(back);
        return;
      }
      /* at most one is ever held, and a later click replaces it so the most
         recent direction wins rather than a stale one firing */
      queuedClick = back ? -1 : 1;
      if (queueTimer) return;
      queueTimer = setTimeout(function () {
        queueTimer = null;
        var held = queuedClick;
        queuedClick = 0;
        if (held) runClickMove(held === -1);
      }, window_ - waited);
    }

    function onClick(event) {
      if (suppressClick) {
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!fine || slides.length < 2) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (event.target.closest && event.target.closest('a, button')) return;

      var rect = slidesEl.getBoundingClientRect();
      var back = event.clientX - rect.left < rect.width / 2;
      requestClickMove(back);
    }

    /* the track position is in px, so a resize invalidates it */
    function onResize() {
      if (dragging) return;
      settle();
    }

    slidesEl.addEventListener('dragstart', onDragStart);
    slidesEl.addEventListener('pointerdown', onPointerDown);
    slidesEl.addEventListener('pointermove', onPointerMove);
    slidesEl.addEventListener('pointerup', onPointerUp);
    slidesEl.addEventListener('pointercancel', onPointerCancel);
    slidesEl.addEventListener('lostpointercapture', onLostCapture);
    slidesEl.addEventListener('click', onClick);
    trackEl.addEventListener('transitionend', onTransitionEnd);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', onResize);
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onBreakpoint);

    recenter();
    syncExposure();
    playAt(current);
    runBar(current);
    warm(nextIndex());
    schedule();

    return {
      root: root,
      selectSlide: function (element) {
        var index = slides.indexOf(element);
        if (index < 0) return;
        editorHold = true;
        clear();
        goTo(index, index < current);
        freezeBar(index);
      },
      releaseSlide: function () {
        editorHold = false;
        runBar(current);
        schedule();
      },
      destroy: function () {
        clear();
        clearQueue();
        dragging = false;
        settle();
        detach();
        slidesEl.removeEventListener('dragstart', onDragStart);
        slidesEl.removeEventListener('pointerdown', onPointerDown);
        slidesEl.removeEventListener('pointermove', onPointerMove);
        slidesEl.removeEventListener('pointerup', onPointerUp);
        slidesEl.removeEventListener('pointercancel', onPointerCancel);
        slidesEl.removeEventListener('lostpointercapture', onLostCapture);
        slidesEl.removeEventListener('click', onClick);
        trackEl.removeEventListener('transitionend', onTransitionEnd);
        document.removeEventListener('visibilitychange', onVisibility);
        window.removeEventListener('resize', onResize);
        if (mobileMq.removeEventListener) {
          mobileMq.removeEventListener('change', onBreakpoint);
        }
        for (var i = 0; i < slides.length; i++) pauseAllIn(i);
      },
    };
  }

  function init() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionId = root.getAttribute('data-section-id');
      if (!sectionId || instances[sectionId]) continue;

      var controller = attach(root);
      if (controller) instances[sectionId] = controller;
    }
  }

  function instanceFor(event) {
    var sectionId = event.detail && event.detail.sectionId;
    return sectionId ? instances[sectionId] : null;
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId || !instances[sectionId]) return;
    instances[sectionId].destroy();
    delete instances[sectionId];
  });

  document.addEventListener('shopify:block:select', function (event) {
    var instance = instanceFor(event);
    if (!instance || !event.target) return;
    var slide = event.target.closest('[data-yg-hc-slide]');
    if (slide) instance.selectSlide(slide);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var instance = instanceFor(event);
    if (instance) instance.releaseSlide();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
